<template>
  <div>
    <h2>Dzienniki urzędowe</h2>

    <div class="table-filter">
      <b-row align-h="between">
        <b-col cols="5">
          <b-input-group>
            <b-form-select aria-label="lista rozwijana rok dziennika" id="rokDz" name="rok dzienników"
                           title="rok dzienników" :value="$store.state.year"
                           @change.native="changeYear($event.target.value)" :options="options"/>
            <!--            <b-input-group>-->
            <b-form-input aria-label="pozycja dziennika" id="pozDz" name="pozycja dziennika" title="pozycja dziennika"
                          placeholder="pozycja dziennika" show-clear
                          type="search"
                          v-model="dziennik_position"
                          @input.native="changePosition($event.target.value)"></b-form-input>

            <!--            <b-input-group-append>-->
            <!--              <b-input-group-text>-->
            <!--                &lt;!&ndash;              <b-button @click="changePosition(null)">Clear</b-button>&ndash;&gt;-->

            <!--                <b-icon icon="x" @click="changePosition(null)"/>-->
            <!--              </b-input-group-text>-->
            <!--            </b-input-group-append>-->
            <!--          </b-input-group>-->
          </b-input-group>
        </b-col>

        <b-col cols="3">
          <form class="searchForm" v-on:submit.prevent="submitSearch">
            <b-input-group>
              <b-form-input v-model="search" type="text" placeholder="Wpisz wyrażenie"></b-form-input>
              <b-input-group-append>
                <b-btn type="submit" text="Szukaj">Szukaj</b-btn>
              </b-input-group-append>
            </b-input-group>
          </form>
        </b-col>
      </b-row>
    </div>

    <div id="wyniki">
      <h5>Odnaleziono {{ total }} wyników dla wyszukiwanej frazy</h5>

      <b-table id="my-table" class="acts-table" striped hover :items="items" :fields="fields" v-if="items.length">
        <template #cell(post_title)="data">
          <router-link :to="'/acts/' + data.item.id"><a>{{ data.item.post_title }}</a>
          </router-link>
        </template>
        <template #cell(date)="data">
          <span>{{ parseDate(data.item.date) }}</span>
        </template>
        <template #cell(post_meta.dziennik_new_pdf)="data">
          <a :href="`${data.item.post_meta.dziennik_new_pdf}`"
             :title="`Plik PDF: ${data.item.post_title}`">PDF</a>
        </template>

      </b-table>

      <b-pagination
        v-model="currentPage"
        @change="changePage"
        :total-rows="total"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import app from '../store/store2'

export default {
  name: 'Acts',
  mounted() {
    var acts;
    let cols = [];

    this.todayDate = '2020';//new Date().toISOString().slice(0, 4)
    cols.push({value: null, text: 'wszystkie'});
    for (let i = 2012; i <= this.todayDate; i++) {
      cols.push({value: i.toString(), text: i.toString()})
    }

    this.options = cols;

    if (localStorage.getItem('acts') !== null) {
      acts = JSON.parse(localStorage.getItem('acts'));
      this.$store.commit('setActs', acts);
    } else {
      acts = this.$store.state.acts;
    }

    if (localStorage.getItem('acts_year') !== null) {
      this.$store.commit('setYear', localStorage.getItem('acts_year'));
    }else {
      this.$store.commit('setYear', this.todayDate);

    }


    if (acts.length) {
      this.items = acts;
    } else {
      const local_year = localStorage.getItem('acts_year');
      let year = null;
      if (!local_year) {
        year = this.todayDate;
      } else {
        year = local_year;
      }

      this.$http.get(app.actsurl + '?per_page='+this.perPage+'&filter[year]=' + year+'&page='+this.currentPage+ '&posts_per_page='+this.perPage).then(response => {
        // console.log(response.headers["x-wp-total"]);
        // console.log(response.headers["x-wp-total"]);
        this.total = response.headers["x-wp-total"];
        this.currentSearchUrl = '?per_page='+this.perPage+'&filter[year]=' + year;

        this.$store.commit('setActs', response.data);
        this.items = response.data;
      });
    }

  },
  created(){

  },
  data() {
    return {
      //selected: 2018,
      todayDate: '',
      dziennik_position: null,
      search: '',
      options: [],
      perPage: 10,
      total: 0,
      currentPage: 1,
      currentSearchUrl: '',

      fields: [
        {key: 'position', label: 'Nr', sortable: false},
        {key: 'post_title', label: 'Tytuł', sortable: false},
        {key: 'year', label: 'Rok', sortable: false},
        {key: 'date', label: 'Opublikowano', sortable: false,},
        {key: 'post_meta.dziennik_new_pdf', label: 'PDF', sortable: false,},
      ],
      items: [],
    }
  },
  methods: {
    parseDate(date) {
      return date.substr(0, 10);
    },
    submitSearch() {
      this.currentPage=1;
      //setTimeout( () => {
      this.$http.get(app.actsurl + '?per_page='+this.perPage+'&filter[s]=' + this.search+ '&posts_per_page='+this.perPage ).then(response => {
        this.items = response.data;
        document.getElementById('wyniki').focus();
        window.location.hash = '#wyniki';

        this.$store.commit('setYear', null);
        this.dziennik_position = null;
        this.total = response.headers["x-wp-total"];
        this.currentSearchUrl = '?per_page='+this.perPage+'&filter[s]=' + this.search ;

      });
      //}, 2000 );
    },
    changeYear(value) {

      //this.selected = this.$store.state.year;
      this.$store.commit('setYear', value);
      this.dziennik_position = null;
      this.search = null;
      this.currentPage = 1;

      this.$http.get(app.actsurl + '?per_page='+this.perPage+'&filter[year]=' + value+ '&posts_per_page='+this.perPage).then(response => {
        this.$store.commit('setActs', response.data);
        this.items = response.data;
        this.total = response.headers["x-wp-total"];
        this.currentSearchUrl = '?per_page='+this.perPage+'&filter[year]=' + value;
      });

    },

    changePage(pageNr){
      this.currentPage = pageNr;
      // console.log(this.currentPage + 'changePage');

      this.$http.get(app.actsurl + this.currentSearchUrl+'&page='+this.currentPage+ '&posts_per_page='+this.perPage).then(response => {
        this.$store.commit('setActs', response.data);
        this.items = response.data;
        this.total = response.headers["x-wp-total"];
        this.search = null;
      });
    },
    changePosition(value) {

      //this.selected = this.$store.state.year;
      this.currentPage =1;
      const year = localStorage.getItem('acts_year');
      let fullUrl = app.actsurl + '?per_page='+this.perPage+'&filter[year]=' + year;
      this.currentSearchUrl = '?per_page='+this.perPage+'&filter[year]=' + year;
      // value =parseInt(value);
      // console.log(typeof value === 'number', value);
      if (typeof parseInt(value) === 'number' && value > 0) {
        this.dziennik_position = value
        fullUrl += '&filter[dziennik_position]=' + value;
        this.currentSearchUrl +='&filter[dziennik_position]=' + value;
      } else {
        this.dziennik_position = null;
      }
      // console.log(fullUrl);

      this.$http.get(fullUrl+ '&posts_per_page='+this.perPage).then(response => {
        this.$store.commit('setActs', response.data);
        this.items = response.data;
        this.total = response.headers["x-wp-total"];
        this.search = null;
      });

    },
    pdfName(fullName) {
      let pieces = fullName.split(/[/,]+/);
      return pieces[pieces.length - 1];
    }
  }
}

</script>

<style scoped>
.table-filter {
  margin-bottom: 10px;
}

.acts-table {
  border: 1px solid #EEE;
}
</style>



// WEBPACK FOOTER //
// src/components/acts.vue